import { useEffect, useState } from "react";
import {
  PagesDataType,
  languagesDataType,
} from "../../interfaces/admin.interface";
import { Helmet } from "react-helmet";
import { message, Modal, Switch, Table, TableProps } from "antd";
import * as Yup from "yup";
import { useFormik } from "formik";
import { PagesService } from "../../services/pages.service";
import { LanguageService } from "../../services/languages.service";
import ErrorMessage from "../../components/shared/ErrorMessage/ErrorMessage";
import MainButton from "../../components/shared/MainButton/MainButton";
import Spinner from "../../components/shared/Spinner/Spinner";
import RichTextEditor from "react-rte";
import ShowImage from "../../components/shared/show-image/ShowImage";
import SelectImage from "../../components/shared/select-image/SelectImage";
import { FaPlus } from "react-icons/fa";
const Pages = () => {
  const [pages, setPages] = useState<PagesDataType[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [editingRecord, setEditingRecord] = useState<PagesDataType | null>(
    null
  );
  const [langs, setLangs] = useState<languagesDataType[]>([]);
  const [langCode, setLangCode] = useState("AZ");
  const [logoFileList, setLogoFileList] = useState<any[]>([]);
  const [editorState, setEditorState] = useState<{ [key: string]: any }>({
    AZ: RichTextEditor.createEmptyValue(),
  });
  const [showImageModal, setShowImageModal] = useState<boolean>(false);
  const [selectedImage, setSelectedImage] = useState<string>("");

  const handleEditorChange = (value: any) => {
    setEditorState((prev) => ({
      ...prev,
      [langCode]: value,
    }));

    const textValue = value.toString("html");

    handleTranslationChange(textValue, "text");
  };

  useEffect(() => {
    setLoading(true);
    PagesService.getAllPages()
      .then((response) => {
        if (Array.isArray(response?.data?.data)) {
          const dataWithKeys = response?.data?.data?.map(
            (item: PagesDataType, index: number) => ({
              ...item,
              key: index + 1,
            })
          );
          setPages(dataWithKeys);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);
  useEffect(() => {
    LanguageService.getAllLanguages().then((response) =>
      setLangs(response?.data)
    );
  }, []);
  const handleAfterSubmit = async () => {
    setLoading(true);
    setIsModalVisible(false);
    resetForm();
    const updatedData = await PagesService.getAllPages();
    setPages(
      updatedData?.data?.data?.map((item: PagesDataType, index: number) => ({
        ...item,
        key: index + 1,
      }))
    );
  };
  const { handleSubmit, values, resetForm, setFieldValue, touched, errors } =
    useFormik({
      initialValues: {
        name: "",
        text: "",
        is_visible: false,
        image: null,
        translations: [] as {
          lang_code: string;
          name: string;
          text: string;
        }[],
      },
      validationSchema: Yup.object({
        name: Yup.string().required("Səhifənin adı tələb olunur"),
        text: Yup.string().required("Səhifənin mətni tələb olunur"),
        // image: Yup.string().required("Səhifənin şəkili tələb olunur"),
      }),
      onSubmit: async (values) => {
        const azTranslation = {
          lang_code: "AZ",
          name: values.name,
          text: values.text,
        };
        const updatedTranslations = [
          azTranslation,
          ...values.translations.filter((t) => t.lang_code !== "AZ"),
        ];
        const finalValues = {
          ...values,
          translations: updatedTranslations,
        };
        if (isEditing && editingRecord) {
          const isEqual =
            editingRecord.name === values.name &&
            editingRecord.text === values.text &&
            editingRecord.is_visible === values.is_visible &&
            editingRecord.image === values.image &&
            editingRecord.translations === values.translations;
          if (isEqual) {
            message.info("Dəyişiklik edilmədi.");
          } else {
            if (editingRecord.image === values.image) {
              const payload = {
                name: values.name,
                text: values.text,
                is_visible: values.is_visible,
                translations: updatedTranslations,
              };
              const response = await PagesService.updatePages({
                ...payload,
                id: editingRecord.id,
              });
              if (response.status === 200) {
                message.success("Səhifə uğurla yeniləndi!");
                await handleAfterSubmit();
              } else {
                message.error(
                  response.errorMessage || "Səhifəni yeniləmək alınmadı."
                );
              }
            } else {
              const response = await PagesService.updatePages({
                ...finalValues,
                id: editingRecord.id,
              });
              if (response.status === 200) {
                message.success("Səhifə uğurla yeniləndi!");
                await handleAfterSubmit();
              } else {
                message.error(
                  response.errorMessage || "Səhifəni yeniləmək alınmadı."
                );
              }
            }
          }
        } else {
          const response = await PagesService.addPages(finalValues);
          if (response.status === 201) {
            message.success("Səhifə uğurla əlavə edildi!");
            await handleAfterSubmit();
          } else {
            message.error(
              response.errorMessage || "Səhifə əlavə etmək alınmadı."
            );
          }
        }
        setLoading(false);
      },
    });
  const handleLanguageButtonClick = (lang: string) => {
    setLangCode(lang);
    const existingTranslation = values.translations.find(
      (t) => t.lang_code === lang
    );

    if (!existingTranslation && lang !== "AZ") {
      setFieldValue("translations", [...values.translations]);
    }
  };
  const handleTranslationChange = (value: string, field: string) => {
    if (langCode === "AZ") {
      if (field === "name") {
        setFieldValue("name", value);
      } else if (field === "text") {
        setFieldValue("text", value);
      }
    } else {
      const updatedTranslations = [...values.translations];
      const existingIndex = updatedTranslations.findIndex(
        (t) => t.lang_code === langCode
      );
      if (existingIndex !== -1) {
        updatedTranslations[existingIndex] = {
          ...updatedTranslations[existingIndex],
          [field]: value,
        };
      } else {
        updatedTranslations.push({
          lang_code: langCode,
          name: field === "name" ? value : "",
          text: field === "text" ? value : "",
        });
      }
      setFieldValue("translations", updatedTranslations);
    }
  };
  const handleSwitchChange = async (checked: boolean, recordId: number) => {
    PagesService.updatePages({
      id: recordId,
      is_visible: checked,
    });
    if (checked) {
      message.success("Səhifə artıq saytda görünür.");
    } else {
      message.info("Səhifə artıq saytda görünmür.");
    }
    setPages((prevData) =>
      prevData.map((item) =>
        item.id === recordId ? { ...item, is_visible: checked } : item
      )
    );
  };

  const columns: TableProps<PagesDataType>["columns"] = [
    {
      title: "№",
      dataIndex: "key",
      sorter: (a, b) => a.key - b.key,
    },
    {
      title: "Səhifənin adı",
      dataIndex: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Səhifənin mətni",
      dataIndex: "text",
      render: (_, record) => (
        <div
          dangerouslySetInnerHTML={{
            __html:
              record?.text.length > 25
                ? record.text.substring(0, 25) + "..."
                : record.text,
          }}
        />
      ),
    },
    {
      title: "Saytda görünürlük",
      dataIndex: "is_visible",
      render: (_, record) => (
        <div className="switch_input">
          <Switch
            checked={record.is_visible}
            onChange={(checked) => handleSwitchChange(checked, record.id)}
          />
        </div>
      ),
    },
    {
      title: "Səhifənin şəkli",
      dataIndex: "image",
      render: (_, record) => (
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            setSelectedImage(record.image!);
            setShowImageModal(true);
          }}
        >
          {record.image ? (
            <img
              style={{ width: "40px" }}
              src={record.image}
              alt={`${record.name.split(" ", 1)}`}
            />
          ) : null}
        </div>
      ),
    },
    {
      title: (
        <div className="settings">
          <i className="fa-solid fa-gear"></i>
        </div>
      ),
      key: "action",
      render: (_, record) => (
        <div className="settings_icons">
          <div className="edit" onClick={() => handleEditClick(record)}>
            <i className="fa-solid fa-pen-to-square"></i>
          </div>
        </div>
      ),
    },
  ];
  const handleAddClick = () => {
    setIsEditing(false);
    setEditingRecord(null);
    setIsModalVisible(true);
    resetForm();
    setLangCode("AZ");
    setFieldValue("image", null);
    setLogoFileList([]);
    setFieldValue("text", "");
    setEditorState({ AZ: RichTextEditor.createEmptyValue() });
  };
  const handleEditClick = (record: PagesDataType) => {
    setIsEditing(true);
    setEditingRecord(record);
    setIsModalVisible(true);
    setFieldValue("name", record.name);
    setFieldValue("text", record.text);
    setFieldValue("image", record.image);
    setFieldValue("is_visible", record.is_visible);
    setFieldValue("translations", record.translations);
    setLangCode("AZ");
    setLogoFileList(
      record.image
        ? [
            {
              uid: "-1",
              name: `${record.name} image`,
              status: "done",
              url: record.image,
            },
          ]
        : []
    );
    const initialEditorState: { [key: string]: any } = {
      AZ: editingRecord?.text
        ? RichTextEditor.createValueFromString(editingRecord?.text, "html")
        : RichTextEditor.createEmptyValue(),
    };
    editingRecord?.translations?.forEach((translation) => {
      initialEditorState[translation.lang_code] = translation.text
        ? RichTextEditor.createValueFromString(translation.text, "html")
        : RichTextEditor.createEmptyValue();
    });

    setEditorState(initialEditorState);
  };

  useEffect(() => {
    if (isEditing) {
      const initialEditorState: { [key: string]: any } = {
        AZ: editingRecord?.text
          ? RichTextEditor.createValueFromString(editingRecord?.text, "html")
          : RichTextEditor.createEmptyValue(),
      };
      editingRecord?.translations?.forEach((translation) => {
        initialEditorState[translation.lang_code] = translation.text
          ? RichTextEditor.createValueFromString(translation.text, "html")
          : RichTextEditor.createEmptyValue();
      });

      setEditorState(initialEditorState);
    }
  }, [editingRecord, isEditing]);

  return (
    <div id="pages">
      <Helmet>
        <title>Orhan Door | Səhifələr</title>
      </Helmet>
      {loading ? (
        <Spinner />
      ) : (
        <div>
          <div className="page_head">
            <h3 className="page_title">Səhifələr</h3>
          </div>

          <div className="pages_components">
            <MainButton onClick={handleAddClick}>
              <FaPlus size={20} />
            </MainButton>
            <div className="pages_table">
              <Table<PagesDataType>
                scroll={{ x: "100%" }}
                columns={columns}
                dataSource={pages}
                rowKey={(record) => record.id.toString()}
                pagination={false}
              />
            </div>
          </div>
        </div>
      )}

      <Modal
        title={isEditing ? "Səhifəni redaktə edin" : "Yeni Səhifə əlavə edin"}
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setEditorState({ [langCode]: RichTextEditor.createEmptyValue() });
        }}
        footer={null}
        style={{ minWidth: "340px" }}
        width={"80%"}
        centered
      >
        <form className="modal_form" onSubmit={handleSubmit}>
          <div className="langs">
            {langs.map((lang, index) => {
              return (
                <div key={index}>
                  <button
                    className={lang.code === langCode ? "active_lang_btn" : ""}
                    type="button"
                    onClick={() => handleLanguageButtonClick(lang.code)}
                  >
                    {lang.name}
                  </button>
                </div>
              );
            })}
          </div>
          <div className="form_input">
            <label className="label" htmlFor="name">
              Səhifənin adı {langCode}
            </label>
            <div className="input_wrapper">
              <input
                name="name"
                id="name"
                placeholder="Səhifənin adı"
                value={
                  langCode === "AZ"
                    ? values.name
                    : values.translations.find((t) => t.lang_code === langCode)
                        ?.name || ""
                }
                onChange={(e) =>
                  handleTranslationChange(e.target.value, "name")
                }
              />
              <span className="focus_border"></span>
            </div>
            <ErrorMessage error={errors.name} touched={touched.name} />
          </div>
          <div className="form_input">
            <label className="ck_label" htmlFor="text">
              Səhifənin mətni {langCode}
            </label>
            <RichTextEditor
              value={editorState[langCode] || RichTextEditor.createEmptyValue()}
              onChange={handleEditorChange}
            />
            <ErrorMessage error={errors.text} touched={touched.text} />
          </div>
          <div className="form_input">
            <SelectImage
              image_name="Şəkil seçin"
              logoFileList={logoFileList}
              setLogoFileList={setLogoFileList}
              field="image"
              setFieldValue={setFieldValue}
            />
            <ErrorMessage error={errors.image} touched={touched.image} />
          </div>
          <div className="form_input">
            <label className="active_label" htmlFor="">
              Səhifənin saytda görünməsi
            </label>
            <Switch
              checked={values.is_visible}
              onChange={(checked) => setFieldValue("is_visible", checked)}
            />
          </div>
          <div>
            <MainButton full type="submit" className="form_add_btn">
              {isEditing ? "Redaktə edin" : "Əlavə edin"}
            </MainButton>
          </div>
        </form>
      </Modal>
      <ShowImage
        showImageModal={showImageModal}
        setShowImagesModal={setShowImageModal}
        image={selectedImage}
      />
    </div>
  );
};

export default Pages;
